import { Injectable } from '@angular/core';

@Injectable()
export class MedicalCaseCommonService {

    // IDs configurados con el catalogo de la base de datos(categorias servicios).
    ID_CATEGORY_SERVICE_LABORATORIO = 1;
    ID_CATEGORY_SERVICE_MEDICAMENTOS = 9;
    ID_CATEGORY_SERVICE_AMBULATORIO = 15;
    ID_CATEGORY_SERVICE_HOSPITALIZACION = 10;
    ID_CATEGORY_SERVICE_INSUMO = 5;

    reason_type = [
        {value: 0, text: 'No hay cobertura con el diagnóstico reportado'},
        {value: 1, text: 'No hay cobertura por condición de la póliza'},
        {value: 2, text: 'No hay cobertura por primas pendientes'},
        {value: 3, text: 'No hay cobertura por preexistencia'},
        {value: 4, text: 'No hay cobertura por exclusión de la póliza'},
        {value: 5, text: 'No hay cobertura por monto mínimo'},
        {value: 6, text: 'No hay cobertura por no cubrir el tiempo de espera'},
        {value: 7, text: 'No hay cobertura por diagnóstico no cubierto en la póliza'},
    ]
    case_sale_status = [
        {value: 0, text: 'Cancelada'},
        {value: 1, text: 'Activa'},
        {value: 2, text: 'Suspendida'},
        {value: 3, text: 'Expirada'},
        {value: 4, text: 'Renovada'}
    ];
    
    default_categories = [
        {value: 0, text: 'Procedimientos Ambulatorios'},
        {value: 1, text: 'Estudios de Diagnóstico'},
        {value: 2, text: 'Hospitalización'},
        {value: 3, text: 'Medicamentos'}
    ];
    
    relationships = [
        {value: 0, text: '---'},
        {value: 1, text: 'Titular'},
        {value: 2, text: 'Cónyuge'},
        {value: 3, text: 'Hijo'},
        {value: 4, text: 'Hija'},
        {value: 5, text: 'Padre'},
        {value: 6, text: 'Madre'}
    ];
    
    form_status = [
       {value: 1, text: 'Ingreso de Información'},
       {value: 2, text: 'Más Información'},
       {value: 3, text: 'Evaluación Médica'},
       {value: 4, text: 'Evaluado'},
       {value: 5, text: 'Auditoría Médica'} ,
       {value:6, text: 'Aprobado'},
       {value:7, text: 'Declinado'},
       {value:11, text: 'Resuelto'},
       {value:12, text: 'Anulado'},
       {value:13, text: 'Modificación'},
       {value:14, text: 'Espera Evaluación Médica'},
       {value:15, text: 'Aprobado Resuelto'},
       {value:16, text: 'Declinado Resuelto'},
       {value:17, text: 'En espera de liquidación'},
       {value:18, text: 'En espera de complementos'},
       {value:19, text: 'Pagado'},
       {value:20, text: 'Pre Autorizacion'}
    ];
    
    ticket_type = [
        {value: 1, text: 'Ingreso de Información'},
        {value: 2, text: 'Más Información'},
        {value: 3, text: 'Evaluación Médica'},
        {value: 4, text: 'Evaluado'},
        {value: 5, text: 'Auditoría Médica'} ,
        {value:6, text: 'Aprobado'},
        {value:7, text: 'Declinado'},
        {value:8, text: 'Archivo'},
        {value: 9, text: 'Cerrado'},
        {value: 10, text: 'Comentario'},
        {value: 11, text: 'Resuelto'},
        {value: 12, text: 'Anulado'},
        {value: 13, text: 'Modificación'},
        {value: 14, text: 'Espera Evaluación Médica'},
        {value: 15, text: 'Aprobado Resuelto'},
        {value: 16, text: 'Declinado Resuelto'},
        {value:17, text: 'En espera de liquidación'},
        {value:18, text: 'En espera de complementos'},
        {value:19, text: 'Pagado'}
    ];

    public getRelative(index){
        for (let i = 0; i < this.relationships.length; i++) {
          const element = this.relationships[i];
          if(element.value == index){
            return element.text;
          }
        }
    
        return "N/A";
      }
    
    public getSaleStatus(index){
        for (let i = 0; i < this.case_sale_status.length; i++) {
            const element = this.case_sale_status[i];
            if(element.value == index){
            return element.text;
            }
        }

        return "N/A";
    }

    public getCategoryName(index){
        for (let i = 0; i < this.default_categories.length; i++) {
            const element = this.default_categories[i];
            if(element.value == index){
                return element.text;
            }
        }

        return "N/A";
    }

    public getFormStatus(index){
        for (let i = 0; i < this.form_status.length; i++) {
            const element = this.form_status[i];
            if(element.value == index){
                return element.text;
            }
        }

        return "N/A";
    }

    public getTicketType(index){
        for (let i = 0; i < this.ticket_type.length; i++) {
            const element = this.ticket_type[i];
            if(element.value == index){
                return element.text;
            }
        }

        return "N/A";
    }

    public getReasonType(index){
        for (let i = 0; i < this.reason_type.length; i++) {
            const element = this.reason_type[i];
            if(element.value == index){
                return element.text;
            }
        }

        return "N/A";
    }
}
